import * as Tooltip from '@radix-ui/react-tooltip';

import TooltipPortal from '@/components/TooltipPortal';
import { cn } from '@/utils/cn';

interface ActionTooltipProps {
  content: string;
  children: React.ReactNode;
}

const ActionTooltip: React.FC<ActionTooltipProps> = ({ content, children }: ActionTooltipProps) => {
  return (
    <Tooltip.Provider delayDuration={300}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
        <TooltipPortal>
          <Tooltip.Content
            side="top"
            sideOffset={2}
            className={cn(
              'select-none p-2 tooltip-surface rounded-md text-xs z-50',
              'transition-all duration-200 ease-out',
              'data-[state=closed]:opacity-0 data-[state=delayed-open]:opacity-100',
            )}
          >
            {content}
          </Tooltip.Content>
        </TooltipPortal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export default ActionTooltip;
